class DesviosStTabsController extends AbstractController
  @$inject = [ '$scope', 'pathService' ]

  constructor: (@scope, pathService) ->
    @url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/icms/desvios-st/tabs/'

    @tabsView = [
      {
        id: 'desvios-st-painel'
        label: 'Painel'
        url: @url + 'painel.html'
      }
    ]


angular.module("eficienciaFiscalModule").controller('desviosStTabsController', DesviosStTabsController)

class DesviosStPainelController
  @$inject = [ '$scope', 'pathService' ]

  constructor: (@scope, pathService) ->
    @url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/icms/desvios-st/tabs/farmaceutico/';

    @buttons = {
      farmaceutico: [
        { label: 'Listas (Positiva, Negativa e Neutra)', url: 'listas/index.html', icon: 'list' },
        { label: 'MVAs', url: 'mvas/index.html', icon: 'book' },
        { label: 'Configurações ANVISA', url: 'configuracoes-anvisa/index.html', icon: 'cogs' },
        { label: 'Tabela ANVISA', url: 'anvisa-itens/index.html', icon: 'table' },
        { label: 'Tabela ABC Farma', url: 'tabela-abc-farma/index.html', icon: 'table' },
        { label: 'Configurações avançadas', url: 'configuracoes-avancadas/configuracoes-avancadas.html', icon: 'cogs' },
        { label: 'Tipo de medicamento por CEST e NCM', url: 'cest/index.html', icon: 'list' },
      ],
    }

  openConfig: (button) ->
    @scope.tabController.addTab({
      id: button.url
      label: button.titleTab or button.label
      closable: true
      url: @url + button.url
    })


angular.module('eficienciaFiscalModule').controller('desviosStPainelController', DesviosStPainelController)